<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mb-3 mt-4">
            <h6>Einheiten im Jahr {{ filterData.year }} fertiggestellt</h6>
            <div class="row mt-4">
              <div class="col-sm-12">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.coachingType"
                        :options="dropdownCoachingType"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg-2 col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.year"
                        :options="dropdownYears"
                        :is-clear="false"
                    />
                  </div>
                  <div class="col-lg col-md-4 col-sm-12">
                    <SelectVue
                        v-model="filterData.locationId"
                        placeholder="Standort"
                        :options="dropdownOffices"
                        :is-clear="true"
                    />
                  </div>

                  <div class="col-auto text-center">
                    <SearchButton
                        :label="$t('general.button.search')"
                        :loading="isSearching"
                        :disabled="!isLoaded"
                        @click="getChartBar(true)"/>
                  </div>
                </div>
                <VueApexCharts width="100%" height="480" type="bar" :options="chartOptionsBar" :series="seriesSignBar"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar
          </h6>
        </template>
      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardAdminService from '@/api/Dashboard/Admin';
import FormSidebar from '@/components/FormSidebar.vue';
import SelectVue from '@/components/SelectVue.vue';
import SearchButton from '@/components/button/SearchButton.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import { getCoachingTypes, getOfficeDropdown, getYears } from '@/shared/dropdowns';
import { getBarColorsByCompany, optionsChartBar } from '@/shared/utils/apex';
import { MonthsUtils } from '@/shared/utils/MonthsUtils';
import { piniaCompanySettingsStore } from '@/store/piniaCompanySettingsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/Admin/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import VueApexCharts from 'vue3-apexcharts';

const { t }                = useI18n();
const dropdownYears        = ref([]);
const dropdownCoachingType = ref([]);
const dropdownOffices      = ref([]);
const isLoaded             = ref(false);
const isSearching          = ref(false);
const seriesSignBar        = ref([]);

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const chartOptionsBar = ref({
  ...optionsChartBar,
  xaxis: {
    categories: MonthsUtils(t),
  },
  colors: getBarColorsByCompany(companySettings.value?.companyKey),
  plotOptions: {
    bar: {
      distributed: false,
    },
  },
});

const filterData = ref({
  coachingType: 'private_coaching',
  year: new Date().getFullYear(),
  locationId: '',
});


async function getChartBar() {
  try {
    isSearching.value = true;
    if (filterData.value.locationId === null || filterData.value.locationId === undefined) {
      filterData.value.locationId = '';
    }
    const { data }      = await dashboardAdminService.getChartData(filterData.value);

    seriesSignBar.value = [
      data.data.chartData.signedUnits,
      data.data.chartData.unsignedUnits,
    ];

    const allValues = [
      ...data.data.chartData.signedUnits.data,
      ...data.data.chartData.unsignedUnits.data,
    ];

    const maxValue = Math.max(...allValues);
    const niceMax = Math.ceil(maxValue / 10) * 10;

    chartOptionsBar.value = {
      ...chartOptionsBar.value,
      chart: {
        ...chartOptionsBar.value.chart,
        height: 480,
      },
      colors: getBarColorsByCompany(companySettings.value?.companyKey),
      yaxis: {
        min: 0,
        max: niceMax,
        tickAmount: 5,
      },
    };

    isSearching.value = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

function getDropdowns() {
  getYears(dropdownYears);
  getCoachingTypes(dropdownCoachingType);
  getOfficeDropdown(dropdownOffices);
}

onMounted(async () => {
  CloseToast();
  getDropdowns();
  await getChartBar();

  isLoaded.value = true;
});
</script>

<style scoped>
/* Optional custom styles */
</style>